import React, { useMemo } from 'react';
import { Form } from 'antd';
import { useSelector } from 'react-redux';
import { useCompaniesQuery } from '../../../../../hooks/useCompaniesQuery';
import { useInstructionQuery } from '../../../../../hooks/useInstructionQuery';
import downloadVoiting from '../../../../../../Voting/containers/voting-item/components/SaveVoiting/downloadVoiting';
import styles from './CompanyBox.module.scss';
import DropdownSelect from '../../../../../../../components/dropdownSelect/DropdownSelect';
import { getRenderControl } from '../../../../../../../components/SingleControlCustom/getRenderControl';
import { useHistory } from 'react-router-dom';
import { links } from '../../../../../constants/links';
import useHousingStockMatch from '../../../../../hooks/useHousingStockMatch';
import { nameTableColumn } from '../../../constants/nameTableRso';

const { Item } = Form;

const CompanyBox = ({ form }) => {
  const { getFieldDecorator, getFieldValue } = form;

  const history = useHistory();
  const match = useHousingStockMatch();

  const currentCompany = useSelector(
    (state) => state.housingStockStore.currentCompany
  );
  const valueForm = useSelector((state) => state.rsoImportStore.valueForm);

  const { data: companies, loading: loadingQueryCompanies } = useCompaniesQuery(
    {
      staleTime: Infinity,
    }
  );

  const { data: dataInstruction, loading: loadingInstruction } =
    useInstructionQuery();

  const onDownloadFile = () => {
    downloadVoiting(dataInstruction, 'Инструкция.pdf');
  };

  const isVisibleInstruction = dataInstruction && currentCompany;
  const hasLoadindDisabled = loadingQueryCompanies || loadingInstruction;

  const optionsCompanies = useMemo(() => {
    if (!companies || !companies.length) return [];

    return companies?.map((company) => ({
      key: company.id,
      value: company.id,
      content: company.name,
    }));
  }, [companies]);

  const handleChange = ({ id }) => {
    if (id !== currentCompany?.id) {
      history.push(`${links.rootWithCompany}/${id}/${match?.params.page}`);
    }
  };

  const handleValuesChange = (value) => {
    const company = companies.find((c) => c.id === value);

    handleChange(company);
  };

  return (
    <div className={styles.root}>
      <Item
        label="Управляющая компания"
        labelCol={{ span: 11, style: { textAlign: 'left' } }}
        wrapperCol={{ span: 13 }}
        style={{ display: 'flex' }}
      >
        {getFieldDecorator(nameTableColumn.serviceCompanyId, {
          initialValue: valueForm?.serviceCompanyId ?? currentCompany?.id,
          rules: [
            {
              required: true,
              message: 'Пожалуйста, выберите управляющую компанию',
            },
          ],
        })(
          <DropdownSelect
            loading={hasLoadindDisabled}
            options={optionsCompanies}
            onChange={handleValuesChange}
            disabled={hasLoadindDisabled}
            multiple={false}
            renderControl={getRenderControl({
              options: optionsCompanies,
              disabled: hasLoadindDisabled,
              value: getFieldValue(nameTableColumn.serviceCompanyId),
            })}
          />
        )}
      </Item>
      {isVisibleInstruction && (
        <div className={styles.instructionsBox}>
          <div
            className={styles.instructions}
            onClick={onDownloadFile}
          >
            Скачать инструкцию
          </div>
        </div>
      )}
    </div>
  );
};

export default CompanyBox;
